<template>
  <div class="w-100">
    <div id="summer-landing-page">
      <div
        id="navbar"
        class="header"
      >
        <div class="logo" />
        <div class="d-flex align-items-center">
          <TheLanguageSwitcher />
          <router-link
            :to="{ name: 'login' }"
            class="login button text-uppercase ml-2"
          >
            {{ $t('login') }}
          </router-link>
        </div>
      </div>

      <div class="sec-1 d-flex align-items-center">
        <div class="container">
          <div class="row">
            <div
              id="headerText"
              class="col-lg-7 d-flex flex-column justify-content-center justify-content-md-start"
            >
              <h1 class="pb-5">
                {{ $t('landing.header.subTitle') }}
                <br>
                & {{ $t('landing.header.title') }}
              </h1>
              <h2 class="pt-3">
                {{ $t('scroll-down-to-get-started') }}
              </h2>

              <div class="text-center py-3">
                <font-awesome-icon
                  id="scrollIcon"
                  :class="[$style.scrollIcon]"
                  icon="chevron-down"
                  size="7x"
                  @click="handleScrollRoundDetail"
                />
              </div>
            </div>
            <div class="col-lg-5 d-none d-lg-flex align-items-end">
              <router-link :to="{ name: 'register' }">
                <b-img
                  alt="screenshot"
                  class="responsive-image players"
                  :src="require('@/assets/images/landingSummer/header-players.png')"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!isRoundLoading && round"
      id="roundWrapper"
    >
      <TheRoundInfoOverview
        :round="round"
        :class="$style.roundInfoWrapper"
      />

      <MyTeamUpcoming
        :round-id="round.id"
        :round="round"
        :selected-athletes="selectedAthletes"
        @onAthletePick="handleAthletePick"
        @onAthletePickRemove="handleAthletePickRemove"
      />
    </div>
    <MainFooter />
    <RegistrationModal
      v-if="isRegistrationModalVisible"
      @onModalClose="isRegistrationModalVisible = false"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VueCookies from 'vue-cookies'
import VueScrollTo from 'vue-scrollto'
import MyTeamUpcoming from '@/pages/Home/Components/MyTeamUpcoming'
import TheLanguageSwitcher from '@/components/Molecules/TheLanguageSwitcher'
import TheRoundInfoOverview from '@/components/Molecules/TheRoundInfoOverview'
import RegistrationModal from './Components/Molecules/RegistrationModal'
import MainFooter from '@/layout/MainFooter'

export default {
  name: 'SignupEplLanding',
  components: {
    MainFooter,
    MyTeamUpcoming,
    RegistrationModal,
    TheLanguageSwitcher,
    TheRoundInfoOverview,
  },
  props: {},
  data() {
    return {
      selectedAthletes: [],
      selectedAthletesIds: [],
      isRegistrationModalVisible: false,
    }
  },
  computed: {
    ...mapState({
      round: state => state['epl-signup/index'].round,
      isRoundLoading: state => state['epl-signup/index'].isRoundLoading,
    }),
    athletes() {
      return this.$store.getters['rounds/assignAthleteIntoRound/getAndSearchAthletesForRound']({
        roundId: this.round.id,
        lang: this.$i18n.locale,
      })
    },
  },
  mounted() {
    this.fetchRound().then(({ id }) => {
      this.fetchAthletes({ roundId: id }).then(() => {
        if (VueCookies.isKey('epl-landing-athletes')) {
          this.selectedAthletesIds = VueCookies.get('epl-landing-athletes')
            .split(',')
            .map((item) => parseInt(item))

          this.refreshSelectedAthletes()
        }
      })
    })
  },
  methods: {
    ...mapActions({
      fetchRound: 'epl-signup/index/fetchRound',
      fetchAthletes: 'epl-signup/index/fetchAthletes',
    }),
    handleAthletePick(params) {
      if (!this.selectedAthletesIds.includes(params.athleteId)) {
        this.selectedAthletesIds.push(params.athleteId)
        this.selectedAthletesIds = Array.from(new Set(this.selectedAthletesIds))
          .filter((athlete) => !!athlete)

        this.storeSelectedAthletes()
        if (this.selectedAthletes.length === 8) {
          this.isRegistrationModalVisible = true
        }
      }
    },
    handleAthletePickRemove(params) {
      const index = this.selectedAthletesIds.indexOf(params.athleteId)
      delete this.selectedAthletesIds[index]
      this.storeSelectedAthletes()
      if (this.selectedAthletesIds.length === 0) {
        VueCookies.remove('epl-landing-athletes')
      }
    },
    handleScrollRoundDetail() {
      VueScrollTo.scrollTo('#roundWrapper', 500)
    },
    refreshSelectedAthletes() {
      this.selectedAthletes = this.athletes.filter(({ id }) => this.selectedAthletesIds.includes(id))
    },
    storeSelectedAthletes() {
      this.refreshSelectedAthletes()
      VueCookies.set(
        'epl-landing-athletes',
        this.selectedAthletesIds,
        '1d'
      )
      VueCookies.set(
        'epl-landing-athletes-round',
        this.round.id,
        '1d'
      )
    },
  },
}
</script>

<style lang="scss" module>
  @import '../../../../assets/scss/variables';
  .roundInfoWrapper {
    border-bottom: 4px solid $color-bleached-silk;
  }
  .scrollIcon {
    color: $color-white;
  }
  #scrollIconWrapper {
    background: rgba(255,255,255,.8);
    border-radius: 50%;
    border: 1px solid $color-midnight-blue;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: -20px;
    left: 50%;
    right: 50%;
    height: 40px;
    width: 40px;
    .scrollIcon {
      color: $color-midnight-blue;
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../../../assets/css/summer-landing.css";

  #summer-landing-page {
    position: relative;
    #headerText {
      transform: translateY(-30px);
    }
  }

  #scrollIcon {
    cursor: pointer;
    animation: mover 1s infinite  alternate;
  }

  @keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }
</style>
